import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { getAuthorByName } from '~/atomic/page/author/author.data';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { Cycle } from '~/atomic/page/author/books/Cycle';
import { SCAuthorPage } from '~/atomic/page/author/styled';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { getAuthTokenFromServer } from '~/feature/authorization/getAuthToken';
import { currentCycleSelector, getCycleBySlug } from '~/feature/cycle/cycleSlice';
import { checkSupportWebp } from '~/feature/supportWebp/checkSupportWebp';
import { AuthorTemplate } from '~/feature/template/AuthorTemplate';
import {
  createStore,
  RootState, useAppSelector,
} from '~/store';

const CyclePage:NextPage<{ cycleSlug: string; }> & LayoutType = ({ cycleSlug }) => {
  const { currentAuthor } = useAppSelector(authorSelector);
  const currentCycle = useAppSelector(currentCycleSelector);

  const title = `Серия ${currentCycle?.name ?? ''} ${currentAuthor?.name ?? ''}`
  + ': читать онлайн';
  const isEmpty = !currentCycle || !currentCycle?.books?.length;

  const description = `${currentCycle?.name ?? ''} автора ${currentAuthor?.name ?? ''}`
  + ' на платформе Букривер ⭐ Серии книг'
  + ' ⭐ Скачивайте полностью книги в формате fb2'
  + ' ⭐ Читайте книги на нашем сайте и добавляйте к себе в библиотеку!';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.cycle.isPublic}
      seo={{
        title,
        image: currentAuthor?.photoUrl,
        description,
        canonical: pagesConfigStore.cycle.as(currentAuthor?.username, cycleSlug),
        customSeoTags: isEmpty && (
          <meta name="robots" content="noindex, nofollow" />
        ),
      }}
      content={(
        <SCAuthorPage>
          <Cycle />
        </SCAuthorPage>
      )}
    />
  );
};

CyclePage.getLayout = (page) => (
  <AuthorTemplate>{ page }</AuthorTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState },
{ authorUsername: string; cycleSlug: string; }
> = async (context) => {
  const { store, dispatch } = await createStore();
  await checkAuthToken(context, dispatch);
  const token = getAuthTokenFromServer(context);

  const cycleSlug = context.params?.cycleSlug;
  const authorUsername = context.params?.authorUsername;

  if (!authorUsername || !cycleSlug) {
    return { notFound: true };
  }

  checkSupportWebp(context.req, dispatch);

  try {
    await Promise.all([
      dispatch(getAuthorByName({ username: authorUsername as string, token })),
      dispatch(getCycleBySlug({ slug: cycleSlug as string, token })),
    ]);

    const { author: { currentAuthor } } = store.getState() as RootState;

    if (!currentAuthor?.id) {
      return { notFound: true };
    }

    const state = store.getState();
    return { props: { state, cycleSlug } };
  } catch (error) {
    console.log('get author, or cycles error', { error });
    const state = store.getState();
    return { props: { state } };
  }
};

export default CyclePage;
